// extracted by mini-css-extract-plugin
export var aniSpin = "F_d";
export var events = "F_bd";
export var events__heading = "F_bm";
export var events__item = "F_bf";
export var events__list = "F_bn";
export var events__title = "F_bg";
export var intro = "F_bc";
export var main = "F_c";
export var nav = "F_bh";
export var nav__item = "F_bk";
export var nav__link = "F_bl";
export var nav__list = "F_bj";